/* src/app/dialogs/article-editor/article-editor.component.css */
.highlight {
  background-color: #ffc107;
  padding: 5px;
}
/*# sourceMappingURL=article-editor.component-M3ETYFXT.css.map */
